import {_API, _CRUD} from "./_Action";
import {RootState} from "../reducer";
import {_CALL_API} from "../../middleware/api";
import {route} from "../../../conf/routes";
import { _PAGINATE } from "./paginateAction";
import { IPagination } from "src/type/paginated";
import { IUser } from "src/type/user";
import { UserCriteria } from "src/type/criteria/userCriteria";

export const ENTERPRISE_INFOS = 'enterprise_infos';

const _ENTERPRISE_INFOS = _CRUD(ENTERPRISE_INFOS);

export const fetchEnterprise = (enterpriseId: string) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [ _ENTERPRISE_INFOS.GET.REQUEST, _ENTERPRISE_INFOS.GET.SUCCESS, _ENTERPRISE_INFOS.GET.FAILURE ],
      route: route.enterprise.get(enterpriseId)
    }
  })
};

export const updateEnterprise = (enterpriseId: string, data: any) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [ _ENTERPRISE_INFOS.UPDATE.REQUEST, _ENTERPRISE_INFOS.UPDATE.SUCCESS, _ENTERPRISE_INFOS.UPDATE.FAILURE ],
      route: route.enterprise.update(enterpriseId, data)
    }
  })
};


export const ENTERPRISE_MEMBERS = 'enterpriseMembers'
const _ENTERPRISE_MEMBERS_PAGINATE = _PAGINATE(ENTERPRISE_MEMBERS)

export const getMembers = () => (dispatch, getState: () => RootState): Promise<IPagination<IUser>> => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const criteria = {
    order_by : "desc",
    sort_by: 'last_name',
    limit: -1
  }
  return dispatch({
    [_CALL_API]: {
      types: [_ENTERPRISE_MEMBERS_PAGINATE.REQUEST, _ENTERPRISE_MEMBERS_PAGINATE.SUCCESS, _ENTERPRISE_MEMBERS_PAGINATE.FAILURE],
      route: route.enterprise.getMembers(enterpriseId,  criteria as UserCriteria)
    }
  })
}

export const toggleMember = (userId: string) => (dispatch, getState: () => RootState): Promise<any> => {
  const actions = _API('toogle_member')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.enterprise.toggleMember(enterpriseId,  userId)
    }
  })
}




// WEBPACK FOOTER //
// ./src/core/redux/action/enterpriseInfosAction.ts